import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-accent-500 text-foreground-950 flex items-center justify-center text-lg">
                <i className="ri-film-line" />
              </span>
              <span className="font-heading font-bold text-lg text-background-50">善良影视</span>
            </div>
            <p className="text-sm leading-relaxed text-background-100/70 max-w-sm">
              专注“善良的小姨子”及相关家庭情感影视内容的在线播放入口与剧情介绍，为影视爱好者提供舒适的观看导航体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">快速导航</h4>
            <ul className="space-y-3 text-sm text-background-100/70">
              <li><Link to="/" className="hover:text-accent-400 transition-colors">首页</Link></li>
              <li><Link to="/category" className="hover:text-accent-400 transition-colors">剧集分类</Link></li>
              <li><Link to="/search" className="hover:text-accent-400 transition-colors">搜索剧集</Link></li>
              <li><Link to="/about" className="hover:text-accent-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">热门剧集</h4>
            <ul className="space-y-3 text-sm text-background-100/70">
              <li><Link to="/detail/kind-sister-in-law" className="hover:text-accent-400 transition-colors">善良的小姨子</Link></li>
              <li><Link to="/detail/neighbor-sunshine" className="hover:text-accent-400 transition-colors">邻家暖阳</Link></li>
              <li><Link to="/detail/alley-households" className="hover:text-accent-400 transition-colors">小巷人家</Link></li>
              <li><Link to="/detail/warm-journey-home" className="hover:text-accent-400 transition-colors">温暖的归途</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm tracking-wide">联系我们</h4>
            <ul className="space-y-3 text-sm text-background-100/70">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400" />
                <span>service@shanliang-tv.example</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400" />
                <span>每日 09:00 - 22:00</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400" />
                <span>在线服务 · 全国</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-lg cursor-pointer hover:bg-accent-500 hover:text-foreground-950 transition-colors">
                <i className="ri-weibo-fill" />
              </span>
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-lg cursor-pointer hover:bg-accent-500 hover:text-foreground-950 transition-colors">
                <i className="ri-wechat-fill" />
              </span>
              <span className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center text-lg cursor-pointer hover:bg-accent-500 hover:text-foreground-950 transition-colors">
                <i className="ri-mail-send-line" />
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-100/60 text-center sm:text-left">
            © 2026 善良的小姨子在线播放 · 本站为影视内容演示站点，全部剧集信息为示例数据。
          </p>
          <p className="text-xs text-background-100/60 text-center sm:text-right">
            播放内容为前端演示，真实播放接口待接入
          </p>
        </div>
      </div>
    </footer>
  );
}